import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Expand = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb490__a">
              <rect
                rx="0"
                height="48"
                width="48"
                y="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb490__a)"
            transform="matrix(1 0 0 -1 0 96)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M40 60.5H8a2 2 0 1 1 0-4h32a2 2 0 1 1 0 4ZM6 67v10a2 2 0 0 0 3.06 1.696l8-5a2.002 2.002 0 0 0 0-3.392l-8-5A2 2 0 0 0 6 67Zm34 2.5H24a2 2 0 1 1 0-4h16a2 2 0 1 1 0 4Zm0 9H24a2 2 0 1 1 0-4h16a2 2 0 1 1 0 4Zm2 7a2 2 0 0 1-2 2H8a2 2 0 1 1 0-4h32a2 2 0 0 1 2 2Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
